export type AddNoteToResourceTranslation = {
  button: {
    open: string;
  };
  dialog: {
    button: {
      cancel: string;
      save: string;
    };
    form: {
      text: string;
    };
    title: string;
  };
};

export const addNoteToResourceTranslation: AddNoteToResourceTranslation = {
  button: {
    open: 'Dodaj notatkę',
  },
  dialog: {
    button: {
      cancel: 'Anuluj',
      save: 'Zapisz',
    },
    form: {
      text: 'Treść',
    },
    title: 'Dodaj notatkę',
  },
};
